import { render, staticRenderFns } from "./GroupNumber.vue?vue&type=template&id=a2034fba"
import script from "./GroupNumber.vue?vue&type=script&lang=js"
export * from "./GroupNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2034fba')) {
      api.createRecord('a2034fba', component.options)
    } else {
      api.reload('a2034fba', component.options)
    }
    module.hot.accept("./GroupNumber.vue?vue&type=template&id=a2034fba", function () {
      api.rerender('a2034fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GroupNumber.vue"
export default component.exports